import { useSetRecoilState } from "recoil";
import {
  incomingChallanItemState,
  incomingItemsModalTitleState,
} from "../../utils/atoms/atoms";

interface IIncomingChallanItemsButton {
  modalId: string;
  modalTitle: string;
  challanId: number; // Optional prop for challan ID
}

const IncomingChallanItemsButton = ({
  modalId,
  modalTitle,
  challanId = 0,
}: IIncomingChallanItemsButton) => {
  const setIncomingModalTitle = useSetRecoilState(incomingItemsModalTitleState);
  const setIncomingChallanId = useSetRecoilState(incomingChallanItemState);

  return (
    <button
      className="styled-btn--dark"
      data-bs-toggle="modal"
      data-bs-target={modalId}
      onClick={() => {
        setIncomingModalTitle(modalTitle);
        setIncomingChallanId(challanId || 0); // Set to 0 if challanId is not provided
      }}
    >
      View
    </button>
  );
};

export default IncomingChallanItemsButton;
